/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-container[_ngcontent-%COMP%]{position:absolute;left:0;right:0;top:0;bottom:0;background:#fff;z-index:10;display:flex;justify-content:center;align-items:center}"];
export { styles as styles };
